import { render, staticRenderFns } from "./BlackGoldSlipPage.vue?vue&type=template&id=7d4a566c"
import script from "./BlackGoldSlipPage.vue?vue&type=script&lang=js"
export * from "./BlackGoldSlipPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports